export const ButtonSize = {
	S: 'S', // 18
	M: 'M', // 26
	L: 'L', // 31
	XL: 'XL', // 39
	XXL: 'XXL', // 47
};

export const ButtonColor = {
	Primary: 'primary',
	PrimaryLight: 'primary-light',
	Copilot: 'copilot',
	Success: 'success',
	Danger: 'danger',
	LightBorder: 'light-border',
	DangerBorder: 'danger-border',
	PrimaryBorder: 'primary-border',
	Link: 'link',
	Collab: 'collab',
	Delete: 'delete',
	Forward: 'forward',
};

export const ButtonIcon = {
	Plus: 'plus',
	Link: 'link',
	Call: 'call',
	EndCall: 'end-call',
	AddUser: 'add-user',
	Camera: 'camera',
	Delete: 'delete',
	Forward: 'forward',
};

export type CustomColorScheme = {
	borderColor: string,
	backgroundColor: string,
	iconColor: string,
	textColor: string,
	hoverColor: string
};
